"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../helpers");

var _Spinner = require("./Spinner.shared");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var spin = (0, _styledComponents.keyframes)(["100%{transform:rotate(360deg)}"]);
/** Generic Spinner component */

var Spinner = function Spinner(props) {
  var _useState = (0, _react.useState)(props.delay === 0),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  (0, _react.useEffect)(function () {
    var timeout = setTimeout(function () {
      setShow(true);
    }, props.delay);
    return function () {
      clearTimeout(timeout);
    };
  }, []);

  if (!show) {
    return null;
  }

  return _react.default.createElement(SpinnerBar, props);
};

exports.Spinner = Spinner;
Spinner.displayName = "Spinner";

var SpinnerBar = _styledComponents.default.div.withConfig({
  displayName: "Spinner__SpinnerBar",
  componentId: "sc-1t000ax-0"
})(["animation:", " 1s infinite linear;position:absolute;", ";"], spin, function (props) {
  var _getSize = (0, _Spinner.getSize)(props),
      width = _getSize.width,
      height = _getSize.height;

  return "\n      background: ".concat((0, _helpers.color)(props.color), ";\n      width: ").concat(width, "px;\n      height: ").concat(height, "px;\n      top: calc(50% - ").concat(height, "px / 2);\n      left: calc(50% - ").concat(width, "px / 2);\n    ");
});

Spinner.defaultProps = {
  delay: 0,
  width: 25,
  height: 6,
  color: "black100"
};
Spinner.displayName = "Spinner";
//# sourceMappingURL=Spinner.js.map